export const query = (fieldName = 'prices') => `
  ${fieldName} (
    order_by: {
      index: asc_nulls_last
    }
  ) {
    id
    category
    amount
    currency
  }
`;

// add to mutation arguments
export const mutationArgs = `
  $prices: [price_insert_input!]!
  $priceRemoveIds: [uuid!]
`;

// add to price field mutation
export const mutations = `
  insert_price(
    objects: $prices,
    on_conflict: {
      constraint: price_pkey
      update_columns: [
        amount
        category
        currency
        index
      ]
    }
  ) {
    affected_rows
    returning {
      id
    }
  }

  delete_price(
    where: {
      id: {
        _in: $priceRemoveIds
      }
    }
  ) {
    affected_rows
  }
`;
